import styled from 'styled-components'

const Cards = styled.div`  
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`
export default Cards;